// import {
//   MdButton,
//   MdInput,
//   MdSelect,
//   MdOption,
//   MdDate,
//   MdUpload,
//   MdIcon,
//   MdCheckbox,
//   MdPopover,
//   MdAutocomplete,
//   MdDialog
// } from "mdesign-plus";
import MdesignPlus from 'mdesign-plus';
import FormItem from "@/components/basic/form/form-item/Index";


export const registrationCmps = {
  install: (Vue, options = {}) => {
    Vue.use(MdesignPlus, options);
    // mdesign.i18n(options.i18n);
    // Vue.component(MdButton.name, MdButton);
    // Vue.component(MdInput.name, MdInput);
    // Vue.component(MdSelect.name, MdSelect);
    // Vue.component(MdOption.name, MdOption);
    // Vue.component(MdDate.name, MdDate);
    // Vue.component(MdUpload.name, MdUpload);
    // Vue.component(MdIcon.name, MdIcon);
    // Vue.component(MdCheckbox.name, MdCheckbox);
    // Vue.component(MdPopover.name, MdPopover);
    // Vue.component(MdAutocomplete.name, MdAutocomplete);
    // Vue.component(MdDialog.name, MdDialog);
    Vue.component("FormItem", FormItem);
  },
};
